var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuUserSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6002 7.74612C15.6002 9.73434 13.9884 11.3461 12.0002 11.3461C10.012 11.3461 8.4002 9.73434 8.4002 7.74612C8.4002 5.75789 10.012 4.14612 12.0002 4.14612C13.9884 4.14612 15.6002 5.75789 15.6002 7.74612Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6002 10.1461C21.6002 11.4716 20.5257 12.5461 19.2002 12.5461C17.8747 12.5461 16.8002 11.4716 16.8002 10.1461C16.8002 8.82063 17.8747 7.74612 19.2002 7.74612C20.5257 7.74612 21.6002 8.82063 21.6002 10.1461Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8002 18.5461C16.8002 15.8952 14.6512 13.7461 12.0002 13.7461C9.34923 13.7461 7.20019 15.8952 7.20019 18.5461V22.1461H16.8002V18.5461Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20019 10.1461C7.20019 11.4716 6.12568 12.5461 4.8002 12.5461C3.47471 12.5461 2.4002 11.4716 2.4002 10.1461C2.4002 8.82063 3.47471 7.74612 4.8002 7.74612C6.12568 7.74612 7.20019 8.82063 7.20019 10.1461Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2002 22.1461V18.5461C19.2002 17.2811 18.874 16.0924 18.3011 15.0593C18.5885 14.9854 18.8897 14.9461 19.2002 14.9461C21.1884 14.9461 22.8002 16.5579 22.8002 18.5461V22.1461H19.2002Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69931 15.0593C5.12641 16.0924 4.8002 17.2811 4.8002 18.5461V22.1461H1.2002V18.5461C1.2002 16.5579 2.81197 14.9461 4.8002 14.9461C5.11065 14.9461 5.41192 14.9854 5.69931 15.0593Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuUserSelected);
export default __webpack_public_path__ + "static/media/menu-user-selected.64c2acd35a497f3574f9f8db360cd315.svg";
export { ForwardRef as ReactComponent };